import { Plane } from 'lucide-react'
import type { BottomNavItem } from '@/registry/types'

export const tripExpensesBottomNav: BottomNavItem[] = [
  { id: 'trips', label: 'Trips', icon: Plane, href: '/apps/trip-expenses' },
]
